import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
export default {
  name: "index",
  computed: {
    ...walletVuex.mapState(["isMobile", "netId", "isWallet"]),
    ...userVuex.mapState(["userInfo", "etherUSD"])
  },
  data() {
    const tab = [{
      label: this.$lang("Trending"),
      value: "trending",
      img: "tab-icon-1"
    }, {
      label: this.$lang("Finalized"),
      value: "finalized",
      img: "tab-icon-2"
    }, {
      label: this.$lang("Top MC"),
      value: "mcap",
      img: "tab-icon-3"
    }, {
      label: this.$lang("New"),
      value: "new",
      img: "tab-icon-4"
    }];
    return {
      selectTab: "trending",
      listPage: {
        total: 100,
        page: 1,
        perPage: 30
      },
      tab,
      list: null,
      isListLoading: true
    };
  },
  watch: {
    selectTab: {
      async handler(newTab, oldTab) {
        if (newTab !== oldTab) {
          this.isListLoading = true;
          this.listPage.page = 1;
          await this.setTokenList();
          this.isListLoading = false;
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$refs.mTransactionRef.onClose();
    this.$nextTick(() => {
      next();
    });
  },
  methods: {
    ...userVuex.mapActions(["getTokenList"]),
    async walletWeb3Init() {
      await this.noWalletWeb3Init();
    },
    async onTab(item) {
      this.setTokenList = item.value;
      await this.setTokenList();
    },
    async setTokenList() {
      let page = this.listPage.page;
      let perPage = this.listPage.perPage;
      const res = await this.getTokenList({
        type: this.selectTab,
        perPage,
        page
      });
      if (!res) {
        this.isListLoading = false;
        return;
      }
      this.isListLoading = false;
      const list = res.items.map(item => {
        return {
          ...item,
          marketCap: item.pool_price !== null ? _v.fmt_pre(_v.bigNumber(_v.fmt_sc(item.pool_price)).times(item.total_supply).times(this.etherUSD), 0) : 0,
          //市值
          tradingVolume: _v.fmt_pre(_v.fmt_sc(item.volume), 2),
          //交易量
          priceGain24h: _v.fmt_pre(item.diff * 100, 2),
          //24小时价格上涨百分比
          sold_token: item.pool_price !== null ? this.bigNumber(item.pool_ether).div(this.maxEther).times(100).toFixed(18) : 0 //当前卖出代币占比
        };
      });

      this.listPage.total = res.total;
      this.list = list;
    },
    async noWalletWeb3Init() {
      this.isListLoading = true;
      await this.setTokenList();
      this.isListLoading = false;
    },
    async onListPage(page) {
      this.listPage.page = page;
      await this.setTokenList();
    }
  },
  mounted() {
    this.noWalletWeb3Init();
  }
};